import { AbilityBuilder, createMongoAbility } from '@casl/ability'

export const { build: VertebraAbilityBuilder } = new AbilityBuilder(createMongoAbility);

